export const bookmarks = [
  {
    label: "Queens Center (many permits and violatiosn)",
    address: {
      boro: "4",
      houseNo: "90-15",
      streetName: "QUEENS BOULEVARD",
    },
  },
  {
    label: "Judy's House",
    address: {
      boro: "4",
      houseNo: "144-67",
      streetName: "41 AVENUE",
    },
  },
  {
    label: "Walgreens",
    address: {
      boro: "4",
      houseNo: "84-20",
      streetName: "Broadway",
    },
  },
  {
    label: "Codwise Place (has additional BINs)",
    address: {
      boro: "4",
      houseNo: "51-58",
      streetName: "CODWISE PLACE",
    },
  },
  {
    label: "Skyview",
    address: {
      boro: "4",
      houseNo: "131-07",
      streetName: "40 ROAD",
    },
  },
];
